import {useFormik} from 'formik'
import AttachmentMultiple from '../../../utils/components/AttachementMultiple'
import {MAX_FILE_SIZE} from '../Modal/NewTicketModal'
import {useState} from 'react'
import {BASE_URL} from '../../config'
import {useAuth} from '../../auth'
import {useMutation, useQueryClient} from 'react-query'
import toast from 'react-hot-toast'
import axios from 'axios'
import {ISendReplyValuesType, TicketReplyType} from '../_model'
import {
  base64ToFile,
  getMimeTypeFromBase64,
  handleAxiosError,
} from '../../../utils/helperFunction/_helper'
import RichTextEditor from '../../../utils/components/rich-text-editor/RichTextEditor'

type Props = {
  assignedUserId: number
  ticketId: number
}

const TICKET_REPLY_URL = `${BASE_URL}/api/protect/ticketReply?ticketId=`
const TICKET_REPLY_ATTACHMENT_URL = `${BASE_URL}/api/protect/addTicketReplyAttachments`
const TICKET_QUERY_URL = `${BASE_URL}/api/protect/ticketQuery?ticketId=`
const TICKET_QUERY_ATTACHMENT_URL = `${BASE_URL}/api/protect/addTicketTicketQueryAttachments`

const TicketReplyQueryForm = ({assignedUserId, ticketId}: Props) => {
  const queryClient = useQueryClient()
  const {currentUser} = useAuth()
  const [previewUrls, setPreviewUrls] = useState<string[]>([])

  const {mutate: addReply} = useMutation({
    mutationKey: ['viewTicket'],
    mutationFn: async ({sendValues}: {sendValues: ISendReplyValuesType}) => {
      toast.loading('Processing..')
      let messageEndpoint = TICKET_REPLY_URL
      let attachmentEndpoint = TICKET_REPLY_ATTACHMENT_URL

      if (currentUser?.id === assignedUserId || currentUser?.user_profile === 2) {
        messageEndpoint = TICKET_REPLY_URL
        attachmentEndpoint = TICKET_REPLY_ATTACHMENT_URL
      } else {
        messageEndpoint = TICKET_QUERY_URL
        attachmentEndpoint = TICKET_QUERY_ATTACHMENT_URL
      }

      const response = await axios.post(`${messageEndpoint}${ticketId}`, sendValues)

      if (sendValues.isAttachment === '1' && response.status === 200) {
        const formData = new FormData()

        formik.values.attachment.forEach((base64: string, index: number) => {
          const mime = getMimeTypeFromBase64(base64) // e.g. "image/jpeg"
          const ext = mime.split('/')[1] || 'png' // e.g. "jpeg"
          const filename = `file_${index}.${ext}`

          const file = base64ToFile(base64, filename)
          formData.append('attaachemt', file)
        })

        await axios.post(
          `${attachmentEndpoint}?ticketId=${ticketId}&id=${response.data.id}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )
      }
    },
    onSuccess: (values) => {
      toast.dismiss()
      toast.success('Successfull')
      console.log(values)
      queryClient.invalidateQueries(['viewTicket'])
      resetForm()
    },
    onError: (error) => {
      toast.dismiss()
      console.log(error)
      const message = handleAxiosError(error)
      toast.error(message)
    },
  })

  const formik = useFormik<TicketReplyType>({
    initialValues: {attachment: [], ticketMessage: ''},
    onSubmit: async (values) => {
      try {
        console.log(values)
        const sendValues: ISendReplyValuesType = {
          ticketMessage: values.ticketMessage,
          isAttachment: values.attachment.length > 0 ? '1' : '0',
        }
        await addReply({sendValues})
      } catch (error) {
        console.log(error)
      }
    },
  })

  const onContentChange = (content: string) => {
    formik.setFieldValue('ticketMessage', content)
  }

  const resetForm = () => {
    formik.resetForm()
    setPreviewUrls([])
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <hr className='my-10' />
      <div className='fv-row mb-7'>
        <label className='fw-semibold fs-5 mb-2'>Message Reply</label>

        <RichTextEditor
          content={formik.values.ticketMessage}
          onContentChange={onContentChange}
          isFile={false}
        />
      </div>

      <div className='fv-row mb-7'>
        <label className='fw-semibold fs-5 mb-2'>Attachment</label>

        <AttachmentMultiple
          formik={formik}
          previewUrls={previewUrls}
          setPreviewUrls={setPreviewUrls}
          acceptFiles='.png, .jpg, .jpeg'
          max_file_size={MAX_FILE_SIZE} // 100KB
        />
      </div>

      <div className='d-flex justify-content-start'>
        <button type='button' className='btn btn-light me-4'>
          Close
        </button>
        <button type='submit' className='btn btn-primary'>
          Send
        </button>
      </div>
    </form>
  )
}

export default TicketReplyQueryForm
